/* eslint-disable key-spacing */
export const defaultPasswordTheme = {
  closeIcon:                'password-clear-icon',
  icon:                     'password-icon',
  iconLeft:                 'icon-left',
  iconRight:                'icon-right',
  input:                    'password-input',
  inputClearable:           'password-input-clearable',
  inputWrapper:             'password-element-wrapper',
  inputWrapperDisabled:     'disabled',
  inputWrapperFocused:      'focused',
  inputWrapperInvalid:      'danger',
  inputWrapperRequired:     'required',
  isHiddenIcon:             'password-is-hidden',
  isVisibleIcon:            'password-is-visible',
  messageDefault:           'password-message-default',
  messageMedium:            'password-message-medium',
  messageStrong:            'password-message-strong',
  messageWeak:              'password-message-weak',
  prefix:                   'password-prefix',
  suffix:                   'password-suffix',
  wrapper:                  'password-wrapper',
};
/* eslint-enable key-spacing */
